
<script setup>
import { defineEmits, defineProps } from 'vue'

const emit = defineEmits(['update:visible'])
const closePop = () => {
  emit('update:visible', false)
}


defineProps({
  'visible': {
    type: Boolean,
    default: false
  }
})

</script>

<template>
  <transition name="fade">
    <div v-if="visible" class="pop-container">
      <div class="pop-content">
        <div class="pop-tips">温馨提示</div>
        <div class="pop-text">没有搜索到该选手，请确认后重新搜索</div>
        <div class="pop-btn" @click="closePop">确定</div>
      </div>
    </div>
  </transition>
</template>


<style scoped>
.pop-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pop-content {
  width: 301px;
  height: 260px;
  background-image: url('./img/ssjgbjb.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pop-tips {
  color: #000000;
  font-size: 1.325rem;
  font-weight: 800;
  text-align: center;
  margin-top: 3.5rem;
}

.pop-text {
  color: #000000;
  font-size: 16px;
  text-align: center;
  margin-top: 1rem;

}

.pop-btn {
  width: 7.3125rem;
  height: 2.5rem;
  background: #3378EB;
  font-size: 1rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: .3125rem;
  margin-top: 2rem;
}

/* 过渡效果 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

/* 单独为内容添加缩放动画 */
.fade-enter-active .pop-content,
.fade-leave-active .pop-content {
  transition: transform 0.5s ease;
}

.fade-enter-from .pop-content,
.fade-leave-to .pop-content {
  transform: scale(0.9);
}

.fade-enter-to .pop-content,
.fade-leave-from .pop-content {
  transform: scale(1);
}
</style>
